/**
 * Created by Bob.Gear on 29/11/2014.
 */
const EICDataStream3GraphicalAnalysis = angular.module('EICDataStream3.graphicalAnalysis', ["nvd3"]) // nvd3ChartDirectives
  .config(function () { });


EICDataStream3GraphicalAnalysis.controller('GraphicalAnalysisController', ['$scope', '$http', 'MEMBERSHIP_CONFIG', 'lookupTables',
  function ($scope, $http, MEMBERSHIP_CONFIG, lookupTables) {
    $scope.componentName = "GraphicalAnalysisController";

    $scope.criteria = { energySectors: ["upstream", "downstream"] };

    $scope.selectedIndustrySectors = [];
    $scope.selectedRegions = [];

    $scope.regions = lookupTables.regions();
    $scope.industrySectors = lookupTables.industrySectors();


    $scope.chartTypes = [
      "multiBarChart",
      "multiBarHorizontalChart",
      "discreteBarChart",
      "lineChart",
      "cumulativeLineChart",
      "pieChart"
    ];

    $scope.options = {
      title: {
        enable: true,
        text: 'Number of Future and Active Projects',
        class: 'h3'
      },
      subtitle: {
        enable: true,
        text: 'Analysed By Industry Sector and Region',
        class: 'h4'
      },

      chart: {
        type: "multiBarChart",
        height: 600,
        margin: {
          top: 20,
          right: 20,
          bottom: 160,
          left: 90
        },
        clipEdge: false,
        staggerLabels: false,
        transitionDuration: 500,
        stacked: true,
        xAxis: {
          axisLabel: 'Region',
          rotateLabels: -45
        },
        reduceXTicks: false,
        yAxis: {
          axisLabel: 'Number of Projects',
          tickFormat: function (yValue) {
            return d3.format(',d')(yValue)
          }
        }

      }
    };

    $scope.getData = function () {
      var a = $http.get('/api/ProjectCountPerRegionAndSector',
        {
          params: {
            industrySectors: $scope.selectedIndustrySectors,
            regions: $scope.selectedRegions
          }
        })
        .then(function (data, status, headers, config) {

          $scope.data = data;

        })
        .catch(function (data, status, headers, config) {
          var i = 0;
        });
    }
    $scope.getData();

    $scope.sectorBreakdownOptions = {
      title: {
        enable: true,
        text: 'Number of Future and Active Projects',
        class: 'h3'
      },
      subtitle: {
        enable: true,
        text: '',
        class: 'h4'
      },

      chart: {
        type: "pieChart",
        labelThreshold: 0.02,
        height: 800,
        margin: {
          top: 20,
          right: 20,
          bottom: 160,
          left: 90
        },
        clipEdge: false,
        staggerLabels: false,
        transitionDuration: 500
      }
    };
    $scope.getSectorBreakdownData = function () {
      var a = $http.get('/api/industrysectorbreakdown',
        { params: { industrySectorID: $scope.selectedIndustrySector.id } })
        .then(function (data, status, headers, config) {

          $scope.sectorBreakdownData = data;

        })
        .catch(function (data, status, headers, config) {
          var i = 0;
        });
    };


    $scope.$watch("selectedIndustrySector", function () {
      if (!$scope.selectedIndustrySector) return;
      $scope.getSectorBreakdownData();
      $scope.sectorBreakdownOptions.subtitle.text = "For Project Types within the " + $scope.selectedIndustrySector.name + " sector"
      // $scope.sectorBreakdownOptions.chart.width = $("#sectorBreakdownContainer").width();
    });

    $scope.generatingCapacityOptions = {
      title: {
        enable: true,
        text: 'Generating Capacity (MW)',
        class: 'h3'
      },
      subtitle: {
        enable: true,
        text: 'Active and future projects, analysed by  Project Type',
        class: 'h4'
      },

      chart: {
        type: "pieChart",
        labelThreshold: 0.02,
        height: 800,
        margin: {
          top: 20,
          right: 20,
          bottom: 160,
          left: 90
        },
        clipEdge: false,
        staggerLabels: false,
        transitionDuration: 500
      }
    };

    $scope.getGeneratingCapacityData = function () {
      var a = $http.get('/api/generatingcapacity')
        .then(function (data, status, headers, config) {

          $scope.generatingCapacityData = data;

        })
        .catch(function (data, status, headers, config) {
          var i = 0;
        });
    };

    $scope.getGeneratingCapacityData();

    $scope.options2 = {
      title: {
        enable: true,
        text: 'Number of New Projects',
        class: 'h3'
      },
      subtitle: {
        enable: true,
        text: 'Analysed By Industry Sector',
        class: 'h4'
      },

      chart: {
        type: "multiBarHorizontalChart",
        height: 800,
        width: 750,
        margin: {
          top: 20,
          right: 20,
          bottom: 160,
          left: 90
        },
        clipEdge: false,
        staggerLabels: false,
        transitionDuration: 500,
        stacked: true,
        xAxis: {
          axisLabel: 'Quarter',
          rotateLabels: -45
        },
        reduceXTicks: false,
        yAxis: {
          axisLabel: 'Number of New Projects',
          tickFormat: function (yValue) {
            return d3.format(',d')(yValue)
          }
        }

      }
    };

    $scope.getData2 = function () {
      var a = $http.get('/api/newprojectcount')
        .then(function (data, status, headers, config) {
          $scope.data2 = data;
        })
        .catch(function (data, status, headers, config) {
          var i = 0;
        });
    }
    $scope.getData2();


  }]);

